export const consultaAgendadaProps = {
  basename: "/plataforma/consultas/agendadas",
};
